import { render, staticRenderFns } from "./JobTable.vue?vue&type=template&id=fdc5875a&scoped=true&"
import script from "./JobTable.vue?vue&type=script&lang=ts&"
export * from "./JobTable.vue?vue&type=script&lang=ts&"
import style0 from "./JobTable.vue?vue&type=style&index=0&id=fdc5875a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc5875a",
  null
  
)

component.options.__file = "JobTable.vue"
export default component.exports